<span *ngIf="showTitle" class="drp-title">
  {{ 'dashboard:Select Time Period' | i18next : { defaultValue: 'Calendar' } }}
</span>

<div class="drp-header">
  <div
    class="drp-header-field"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger">
    <div class="drp-header-preset">
      {{ headerPresetLabel }}
    </div>
    <div class="drp-header-range">
      {{ headerRangeLabel }}
    </div>
    <div class="drp-header-icon">
      <i class="far fa-calendar"></i>
    </div>
  </div>
</div>

<mat-menu #menu="matMenu" class="drp-menu-panel" (closed)="onMenuClosed()">
  <div
    class="drp-menu-container"
    (click)="$event.stopPropagation()"
    (keydown.tab)="$event.stopPropagation()"
    (keydown.shift.tab)="$event.stopPropagation()">

    <!-- PRESETS -->
    <div class="drp-presets">
      <div class="drp-presets-title">
        {{ 'dashboard:Presets' | i18next : { defaultValue: 'Presets' } }}
      </div>

      <button
        mat-button
        *ngFor="let p of presets"
        (click)="selectPreset(p.key)"
        [class.selected]="selectedPreset === p.key"
        class="drp-preset-btn">
        {{ p.i18nKey | i18next : { defaultValue: p.defaultLabel } }}
      </button>

      <button
        mat-button
        (click)="selectPreset('custom')"
        [class.selected]="selectedPreset === 'custom'"
        class="drp-preset-btn drp-preset-custom">
        {{ 'dashboard:Custom' | i18next : { defaultValue: 'Custom' } }}
      </button>
    </div>

    <!-- RIGHT SIDE: 2 CALENDARS + DATE/TIME INPUTS -->
    <div class="drp-right">
      <div class="drp-calendars">
        <mat-calendar
          #calendarFrom
          [headerComponent]="customHeader"
          [startAt]="leftViewDate"
          [minDate]="minDateMoment"
          [maxDate]="maxDateMoment"
          [dateClass]="dateClass"
          [class.first-calendar]="true"
          (selectedChange)="onCalendarDateClick($event)">
        </mat-calendar>

        <mat-calendar
          #calendarTo
          [headerComponent]="customHeader"
          [startAt]="rightViewDate"
          [minDate]="minDateMoment"
          [maxDate]="maxDateMoment"
          [dateClass]="dateClass"
          (selectedChange)="onCalendarDateClick($event)">
        </mat-calendar>
      </div>

      <div class="drp-bottom">
        <!-- LEFT (FROM) -->
        <div class="drp-bottom-row">
          <div class="drp-input-group">
            <label>Date from</label>
            <input
              type="text"
                [disabled]="disableDateInputs"
              [ngModel]="fromDate?.format('DD.MM.YYYY')"
              (ngModelChange)="onFromDateInputChange($event)" />
          </div>

          <div class="drp-input-group">
            <label>Time from</label>
            <input
              type="text"
              [(ngModel)]="fromTime"
              (ngModelChange)="onFromTimeChange($event)" />
          </div>
        </div>

        <!-- THE DASH -->
        <div class="drp-separator">–</div>

        <!-- RIGHT (TO) -->
        <div class="drp-bottom-row">
          <div class="drp-input-group">
            <label>Date to</label>
            <input
              type="text"
              [disabled]="disableDateInputs"
              [ngModel]="toDate?.format('DD.MM.YYYY')"
              (ngModelChange)="onToDateInputChange($event)" />
          </div>

          <div class="drp-input-group">
            <label>Time to</label>
            <input
              type="text"
              [(ngModel)]="toTime"
              (ngModelChange)="onToTimeChange($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-menu>
